import { getAllApplicationContainersGrouped } from "services/requests/v1/container";

import {
    AppsContainerGroup,
    AppsContainerModel,
    AppsCreateMode,
    AppsEditMode,
    AppsModalContent,
    EditModalDataType,
    HandleOpenModalType,
} from "types/apps-container";
import {
    SetRequestError,
    SetStateType,
    SubscribeContentType,
    UnsubscribeContentType,
} from "types/generic";

type MakeAppsContainersTabFunctionsParams = {
    modalContent: AppsModalContent;
    editMode: AppsEditMode;
    createMode: AppsCreateMode;
    editActive: boolean;
    isAdminUser: boolean;
    isImplantUser: boolean;
    setContainers: SetStateType<AppsContainerModel>;
    setCreateMode: SetStateType<AppsCreateMode>;
    setCreateSubgroupTarget: SetStateType<string>;
    setModalContent: SetStateType<AppsModalContent>;
    setEditModalData: SetStateType<EditModalDataType[]>;
    setEditModalGroupName: SetStateType<string>;
    subscribeContent: SubscribeContentType;
    unsubscribeContent: UnsubscribeContentType;
    setError: SetRequestError;
    setEditMode: SetStateType<AppsEditMode>;
    setContainerId: SetStateType<number | null>;
};

export const makeAppsContainersTabFunctions = ({
    createMode,
    editMode,
    modalContent,
    editActive,
    isAdminUser,
    isImplantUser,
    setContainers,
    setCreateSubgroupTarget,
    setModalContent,
    setEditModalData,
    setEditModalGroupName,
    setError,
    subscribeContent,
    unsubscribeContent,
    setEditMode,
    setCreateMode,
    setContainerId,
}: MakeAppsContainersTabFunctionsParams) => {
    const handleOpenModal: HandleOpenModalType = ({
        content,
        data,
        itemToEditName,
        containerId = null,
        editMode,
    }) => {
        if (!content) return;

        setContainerId(containerId);
        setModalContent(content);
        setEditModalData(data);
        setEditModalGroupName(itemToEditName);
        setEditMode(editMode);
    };

    const handleCloseModal = () => setModalContent(null);

    const loadContainersdata = async () => {
        const contentName = "homePage";
        subscribeContent(contentName);

        try {
            const { data } = await getAllApplicationContainersGrouped();

            setContainers({ ...data });
            unsubscribeContent(contentName);
        } catch (error) {
            setError(contentName);
        }
    };

    const defineModalTitle = () => {
        if (modalContent === "edit") {
            return `app.welcome.page.edit_${
                editMode === "group" ? "group" : "subgroup"
            }`;
        }

        if (modalContent === "delete") {
            return "app.Components.warning.title";
        }

        return `app.welcome.page.add_${createMode}`;
    };

    const openCreateGroupModal = () => {
        setCreateMode("group");
        setModalContent("create");
    };

    const openCreateSubGroupModal = (target: string) => {
        setCreateSubgroupTarget(target);
        setCreateMode("subgroup");
        setModalContent("create");
    };

    const checkHasGoAiguaContent = (container: AppsContainerGroup[]) => {
        return container.some((group) => group.goAigua);
    };

    const handleCloseCreateModal = () => {
        setCreateSubgroupTarget("");
        handleCloseModal();
    };

    const addButtonShouldRender = () => {
        if (!editActive) return false;
        if (isAdminUser || isImplantUser) return true;

        return false;
    };

    return {
        handleCloseModal,
        handleOpenModal,
        loadContainersdata,
        defineModalTitle,
        openCreateGroupModal,
        openCreateSubGroupModal,
        checkHasGoAiguaContent,
        handleCloseCreateModal,
        addButtonShouldRender,
    };
};
